import { Controller } from "@hotwired/stimulus";

// This controller preserves the full-width styling when Turbo replaces watchlist buttons
export default class extends Controller {
  connect() {
    // Set up necessary event listeners
    document.addEventListener(
      "turbo:before-render",
      this.beforeRenderHandler.bind(this)
    );
    document.addEventListener(
      "turbo:render",
      this.afterRenderHandler.bind(this)
    );

    // Apply full width on initial connect if needed
    this.applyFullWidthIfNeeded();
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-render",
      this.beforeRenderHandler.bind(this)
    );
    document.removeEventListener(
      "turbo:render",
      this.afterRenderHandler.bind(this)
    );
  }

  beforeRenderHandler(event) {
    const newFrame = event.detail.newBody.querySelector(`#${this.element.id}`);
    if (!newFrame) return;

    // Preserve the full-width attribute in the new frame
    if (this.element.hasAttribute("data-full-width")) {
      const fullWidth = this.element.getAttribute("data-full-width");
      newFrame.setAttribute("data-full-width", fullWidth);
    }
  }

  afterRenderHandler(event) {
    // After the content is rendered, check if we need to fix any buttons
    const frame = document.getElementById(this.element.id);
    if (frame) {
      this.applyFullWidthToFrame(frame);
    }
  }

  applyFullWidthIfNeeded() {
    // Apply full width to the current frame if needed
    const fullWidth = this.element.getAttribute("data-full-width");
    if (fullWidth === "true") {
      this.applyFullWidthToFrame(this.element);
    }
  }

  applyFullWidthToFrame(frame) {
    const fullWidth = frame.getAttribute("data-full-width");
    if (fullWidth === "true") {
      // Find all buttons and links within the frame
      const buttons = frame.querySelectorAll("button, a");
      buttons.forEach((button) => {
        button.classList.add("justify-center", "w-full");
      });

      // Handle inner form elements too
      const forms = frame.querySelectorAll("form");
      forms.forEach((form) => {
        if (form.hasAttribute("data-full-width")) {
          // Form might have buttons or other elements needing width
          const formButtons = form.querySelectorAll(
            "button, input[type='submit']"
          );
          formButtons.forEach((button) => {
            button.classList.add("justify-center", "w-full");
          });
        }
      });
    }
  }
}
